import React from 'react';
import PortalHeader from '../../components/Portal/PortalHeader';
import { usePortalInvoices } from '../../hooks/portal/usePortal';
import './EstadoCuenta.scss';

const EstadoCuenta = () => {
  const { invoices, summary, loading } = usePortalInvoices();

  if (loading) {
    return (
      <div className="portal-page">
        <PortalHeader />
        <div className="portal-page__loading">Cargando...</div>
      </div>
    );
  }

  return (
    <div className="portal-page estado-cuenta">
      <PortalHeader />

      <div className="portal-page__container">
        <h1 className="portal-page__title">Estado de Cuenta</h1>

        {summary && (
          <div className="estado-cuenta__summary">
            <div className="summary-card">
              <h3>Total Pendiente</h3>
              <p className="amount">${summary.total_outstanding?.toFixed(2)}</p>
            </div>
            <div className="summary-card overdue">
              <h3>Facturas Vencidas</h3>
              <p className="amount">${summary.overdue_amount?.toFixed(2)}</p>
            </div>
            <div className="summary-card paid">
              <h3>Pagado Este Mes</h3>
              <p className="amount">${summary.paid_this_month?.toFixed(2)}</p>
            </div>
          </div>
        )}

        <div className="estado-cuenta__invoices">
          <h2>Facturas</h2>
          {invoices && invoices.length > 0 ? (
            <div className="invoices-table">
              <div className="invoices-table__header">
                <span>Número</span>
                <span>Fecha</span>
                <span>Vencimiento</span>
                <span>Total</span>
                <span>Estado</span>
              </div>
              {invoices.map((invoice) => (
                <div key={invoice.id} className="invoices-table__row">
                  <span>{invoice.invoice_number}</span>
                  <span>{new Date(invoice.created_at).toLocaleDateString()}</span>
                  <span>{new Date(invoice.due_date).toLocaleDateString()}</span>
                  <span>${invoice.total?.toFixed(2)}</span>
                  <span className={`status status--${invoice.status}`}>{invoice.status}</span>
                </div>
              ))}
            </div>
          ) : (
            <p className="empty-state">No hay facturas pendientes</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default EstadoCuenta;
